export const POSITION_MAPPING = {
  leftTop: 'right-full',
  leftBottom: 'right-full top-0 bottom-auto',
  rightTop: 'left-full',
  rightBottom: 'left-full top-0 bottom-auto',
} as const;
